@if (externalReviewsNormalized()?.data?.ReviewSummary) {
  <h2 class="text-xl font-bold mb-5 text-grey-0">Hur upplevs mottagningen?</h2>

  @if (topProsAndCons() && topProsAndCons().length > 0) {
    <div class="flex flex-col gap-8 mb-5">
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: {items: topProsAndCons()}"
      ></ng-container>
    </div>
  }

  <div (click)="goToReviews()" class="text-duck-blue-2 cursor-pointer underline">Se alla åsikter och omdömen</div>
}

<ng-template #itemTemplate let-items="items">
  <div class="flex flex-col gap-1">
    @for (item of items; track item.text) {
      <div class="flex flex-row justify-start gap-2 items-center">
        <div class="w-6 flex justify-center items-center">
          @if (item.type === ProsAndConsTypeEnum.PROS) {
            <app-ui-icon
              color="var(--success-2)"
              name="heart_filled"
              size="sm"></app-ui-icon>
          }
          @if (item.type === ProsAndConsTypeEnum.CONS) {
            <app-ui-icon
              color="var(--error-1)"
              name="close"
              size="sm"></app-ui-icon>
          }
        </div>
        <div>{{ item.text }}</div>
      </div>
    }
  </div>
</ng-template>
